import { render, staticRenderFns } from "./AdminStatsCoverage.vue?vue&type=template&id=db7174dc&scoped=true&"
import script from "./AdminStatsCoverage.vue?vue&type=script&lang=js&"
export * from "./AdminStatsCoverage.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatsCoverage.vue?vue&type=style&index=0&id=db7174dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7174dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db7174dc')) {
      api.createRecord('db7174dc', component.options)
    } else {
      api.reload('db7174dc', component.options)
    }
    module.hot.accept("./AdminStatsCoverage.vue?vue&type=template&id=db7174dc&scoped=true&", function () {
      api.rerender('db7174dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminStatsCoverage.vue"
export default component.exports